import Modal from "./Modal";

import LocationEditor from "../editors/LocationEditor";

const LocationModal = ({ locationId, open, onClose, onSave }) => {
  return (
    <Modal
      title={locationId ? "location_update" : "location_new"}
      open={open}
      onClose={onClose}
    >
      <LocationEditor
        locationId={locationId}
        onSave={onSave || onClose}
      />
    </Modal>
  );
};

export default LocationModal;
